import { combineReducers } from "redux";
import {
  CHANGE_NEIGHBOURHOOD_STATUS_REQUEST,
  CHANGE_NEIGHBOURHOOD_WEIGHT_REQUEST,
  FETCH_NEIGHBOURHOODS_REQUEST,
  FETCH_NEIGHBOURHOOD_DETAIL_REQUEST,
  FETCH_ALL_NEIGHBOURHOODS_REQUEST,
} from "./constants";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action, NeighbourhoodsState } from "./types";

function items(
  state: NeighbourhoodsState = { currentPage: 0, pageCount: 1, data: [] },
  action: Action
): NeighbourhoodsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_NEIGHBOURHOODS_REQUEST):
    case getSuccessActionType(FETCH_ALL_NEIGHBOURHOODS_REQUEST):
    case getSuccessActionType(FETCH_NEIGHBOURHOOD_DETAIL_REQUEST):
      return action.payload;

    case CHANGE_NEIGHBOURHOOD_STATUS_REQUEST:
    case CHANGE_NEIGHBOURHOOD_WEIGHT_REQUEST: {
      return {
        ...state,
        data: state.data.map((neighbourhood) =>
          neighbourhood.id === action.data.neighbourhoodId
            ? { ...neighbourhood, isFetching: true }
            : neighbourhood
        ),
      };
    }

    case getSuccessActionType(CHANGE_NEIGHBOURHOOD_STATUS_REQUEST):
    case getSuccessActionType(CHANGE_NEIGHBOURHOOD_WEIGHT_REQUEST):
      return {
        ...state,
        data: state.data.map((neighbourhood) =>
          neighbourhood.id === action.data.neighbourhoodId
            ? { ...action.payload, isFetching: false }
            : neighbourhood
        ),
      };

    case getFailureActionType(CHANGE_NEIGHBOURHOOD_STATUS_REQUEST):
    case getFailureActionType(CHANGE_NEIGHBOURHOOD_WEIGHT_REQUEST):
      return {
        ...state,
        data: state.data.map((neighbourhood) =>
          neighbourhood.id === action.data.neighbourhoodId
            ? { ...neighbourhood, isFetching: false }
            : neighbourhood
        ),
      };

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_NEIGHBOURHOODS_REQUEST:
    case FETCH_ALL_NEIGHBOURHOODS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_NEIGHBOURHOODS_REQUEST):
    case getFailureActionType(FETCH_NEIGHBOURHOODS_REQUEST):
    case getSuccessActionType(FETCH_ALL_NEIGHBOURHOODS_REQUEST):
    case getFailureActionType(FETCH_ALL_NEIGHBOURHOODS_REQUEST):
      return false;
    default:
      return state;
  }
}

export const neighbourhoods = combineReducers({ items, isFetching });
